import axios from "axios";
const access_token = localStorage.getItem("access_token");

export default class AdminClient {
  constructor() {
    this.httpClient = axios.create({
      baseURL: `${process.env.VUE_APP_APIURL}/api/admin`,
      headers: { Authorization: `${access_token}` }
    });
  }

  async resetPassword(params) {
    return this.httpClient
      .post("director/reset-password", params)
      .then(res => res.data);
  }

  async disconnectCorpDirector(params) {
    return this.httpClient
      .post("director/disconnect-corp", params)
      .then(res => res.data);
  }

  async getFaqList(params) {
    return this.httpClient.post("faq/faq-page", params).then(res => res.data);
  }

  async getNoticeList(params) {
    return this.httpClient
      .post("notice/notice-page", params)
      .then(res => res.data);
  }
  async getNoticeDetail(noticeId) {
    return this.httpClient
      .get(`notice/notice-detail?id=${noticeId}`)
      .then(res => res.data);
  }

  async getQnaList(params) {
    return this.httpClient.post(`qna/qna-page`, params).then(res => res.data);
  }

  async getQnaDetail(qnaId) {
    return this.httpClient.get(`qna/detail?id=${qnaId}`).then(res => res.data);
  }

  async registQna(params) {
    return this.httpClient.post("qna/regist", params).then(res => res.data);
  }
}
